module.exports = "pegasus/assets/blocks/column-lp9-themelp1.png";